import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-6 text-center font-sans">
          <div className="text-7xl mb-6">⚠️</div>
          <h1 className="text-2xl font-black text-white uppercase tracking-widest mb-3">
            Κάτι πήγε στραβά
          </h1>
          <p className="text-gray-400 mb-2 max-w-md">
            Παρουσιάστηκε ένα απροσδόκητο σφάλμα. Δοκιμάστε να ανανεώσετε τη σελίδα.
          </p>
          <p className="text-gray-600 text-sm mb-8 max-w-md">
            Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη.
          </p>
          <div className="flex gap-4">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors"
            >
              🔄 Ανανέωση σελίδας
            </button>
            <button
              onClick={this.handleReset}
              className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-bold rounded-lg transition-colors"
            >
              ↩️ Επιστροφή
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
